module.exports = "../static/media/SweetBinge.d0c59fb4.svg";